import { render, staticRenderFns } from "./Importateurs.vue?vue&type=template&id=b099ce00&"
import script from "./Importateurs.vue?vue&type=script&lang=js&"
export * from "./Importateurs.vue?vue&type=script&lang=js&"
import style0 from "./Importateurs.vue?vue&type=style&index=0&id=b099ce00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports